var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { invariant, isModelSchema } from '../utils/utils';
import { getModelSchema } from '../api/getDefaultModelSchema';
import { serialize } from '../core/serialize';
import { deserializeObjectWithSchema } from '../core/deserialize';
import { bound } from '../../decorators/basic';
export class SerializrType_object {
    modelSchema_raw;
    objectTypeOptions;
    constructor({ modelSchema, objectTypeOptions }) {
        this.modelSchema_raw = modelSchema;
        this.objectTypeOptions = objectTypeOptions || {};
    }
    get modelSchema() {
        const modelSchema = getModelSchema(this.modelSchema_raw);
        invariant(isModelSchema(modelSchema), `expected modelSchema, got ${this.modelSchema_raw}`);
        return modelSchema;
    }
    serializer({ value: item }) {
        if (item === null || item === undefined)
            return item;
        return serialize(item, this.modelSchema);
    }
    deserializer(context) {
        const childJson = context.json;
        // : undefined | AnyEntity
        let target = context.oldValue;
        if (childJson === null || childJson === undefined)
            return childJson;
        let itemModelSchema = this.modelSchema_raw;
        if (this.objectTypeOptions.dynamicItemModelSchema) {
            itemModelSchema = this.objectTypeOptions.dynamicItemModelSchema(childJson, context.objectContext);
        }
        itemModelSchema = getModelSchema(itemModelSchema);
        invariant(isModelSchema(itemModelSchema), `expected modelSchema, got ${itemModelSchema}`);
        // @ts-ignore
        if (target && target.serializeInfo !== itemModelSchema.serializeInfo) {
            target = undefined;
        }
        return deserializeObjectWithSchema(context.objectContext, itemModelSchema, childJson, {
            target,
            parentDepth: this.objectTypeOptions.parentDepth
        });
    }
}
__decorate([
    bound
], SerializrType_object.prototype, "serializer", null);
export function object(modelSchema, objectTypeOptions = {}) {
    invariant(typeof modelSchema === 'object' || typeof modelSchema === 'function', 
    // No modelschema provided. If you are importing it from another file be aware of circular dependencies.
    'No modelschema');
    return new SerializrType_object({ modelSchema, objectTypeOptions });
}
